import { ApiCoursesCartIsAvailableForStudentOrder } from 'ApiRest/Api/Courses/Cart/IsAvailableForStudentOrder'

export default {
  async fetchIsAvailableForStudentOrder({ commit }) {
    const { data } = await ApiCoursesCartIsAvailableForStudentOrder.get()

    commit('setIsAvailableForStudentOrder', data)
  },
}
